module.exports = __webpack_public_path__ + "static/media/20 Stack.85c4e981.jpg";